/**
 * Google Maps react component that renders children as map controls, inspired by below:
 * https://github.com/google-map-react/google-map-react/issues/687#issuecomment-442415573
 * https://reactjs.org/docs/integrating-with-other-libraries.html
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import isString from 'lodash/isString'
import styles from './MapControl.module.scss'

class MapControl extends Component {
  static propTypes = {
    children: PropTypes.node,
    map: PropTypes.object,
    maps: PropTypes.object,
    position: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  state = {
    el: null
  }

  componentWillUnmount = () => {
    this.removeElementFromMap(this.state.el)
  }

  getNumericPosition = () => {
    const { position, maps } = this.props

    if (isString(position)) {
      return maps.ControlPosition[position]
    }

    return position
  }

  pushElementIntoMap = (el) => {
    if (!el) return

    const { map, maps } = this.props
    if (!map || !maps) return

    const position = this.getNumericPosition()
    if (!position) return

    map.controls[position].push(el)
    this.setState({ el })
  }

  removeElementFromMap = (el) => {
    if (!el) return

    const { map, maps } = this.props
    if (!map || !maps) return

    const position = this.getNumericPosition()
    if (!position) return

    const index = map.controls[position].getArray().indexOf(el)
    if (index >= 0) {
      map.controls[position].removeAt(index)
    }
  }

  render () {
    const { map, maps, children } = this.props
    if (!map || !maps) return (<noscript />)

    const position = this.getNumericPosition()
    if (!position) return (<noscript />)

    return (
      <div ref={this.parent}>
        <div
          className={cx(styles['el'], { [styles['pushedToMap']]: !!this.state.el })}
          ref={el => {
            if (this.state.el !== el) {
              this.removeElementFromMap(el)
              this.pushElementIntoMap(el)
            }
          }}>
          {children}
        </div>
      </div>
    )
  }
}

export default MapControl
